import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getTotalApproverList = createApi(`TotalApproverListSlice`,"GET");

const TotalApproverListSlice = createSlice({
  name: 'TotalApproverListSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTotalApproverList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTotalApproverList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getTotalApproverList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default TotalApproverListSlice.reducer;